<ng-container>
    <app-grid-client-side
        #rawMaterialsGridComponent
        [headerCheckboxSelection]="true"
        (areRowsSelected)="handleSelectionChange($event)"
        (rowClicked)="rowClicked($event)"
        [hidden]="!gridPath"
        [tableData]="tableData[0]"
        [fixedButtons]="fixedButtons"
        (deleteChange)="deleteRawMaterials($event)"
        (gridReadyEmitter)="onGridReady()"
        (filterChangedEmitter)="onFilterChangedEmitter($event)"
        [exportFormatterOptions]="exportFormatterOptions"
        (clickableAction)="actions($event)"
        feature="raw_materials"
    ></app-grid-client-side>
</ng-container>